const getEnvironment = () => {
  if (window.location.host.includes('localhost')) {
    return 'localhost';
  }
  if (window.location.host.includes('appqa')) {
    return 'qa';
  }
  if (window.location.host.includes('appstaging')) {
    return 'staging';
  }
  if (window.location.host.includes('app.')) {
    return 'production';
  }
}

export default getEnvironment;
